<template>
  <div class="response-performance-container flex-grow-1 d-flex flex-column">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active"> {{ webpage.name }} - {{ webpage.url }} </span>
    </div>
    <div class="a-body flex-grow-1">
      <div class="pt-10-px pl-19-px mb-20-px">
        <a-select size="default" :defaultValue="'1'" style="width: 360px;" @change="handleChangeFilterChart">
          <a-select-option v-for="(valueTimeline, keyTimeline) in filterChartOptions" :key="keyTimeline" :value="keyTimeline">
            {{ valueTimeline.name }}
          </a-select-option>
        </a-select>
      </div>
      <div class="performance-chart-container px-40-px pb-32-px">
        <div :key="performanceChartKey" :style="{ width: '100%' }" class="slide-up-enter-active">
          <PerformanceChart :chartData="chartData" :timeUnit="timeUnit" :timeUnitStepSize="timeUnitStepSize" :timeUnitMin="timeUnitMin" />
        </div>
        <div class="mt-30-px slide-up-enter-active">
          <div class="bg-blue d-inline-block vertical-align-middle mr-10-px label-desc"></div>
          <p class="d-inline-block mb-0"><small>URL response time (seconds)</small></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import WebpageService from '../services/webpage.service';
  import PerformanceChart from '../components/PerformanceChart';

  export default {
    name: 'ResponsePerformance',
    components: {
      PerformanceChart
    },
    props: {
      webpagePropData: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        filterChartOptions: {},
        hasProps: false,
        webpage: {},
        chartData: {},
        timeUnit: 'hour',
        timeUnitStepSize: 2,
        timeUnitMin: null,
        performanceChartKey: ''
      };
    },
    created() {
      this.hasProps = this.webpagePropData && Object.keys(this.webpagePropData).length;
    },
    beforeMount() {
      const curretTime = new Date().getTime();
      this.filterChartOptions = [1, 3, 7, 14, 31].reduce((result, item) => {
        const name = 'Last ' + (item === 1 ? '24 Hours' : `${item} Days`);
        const value = item === 1 ? moment(curretTime).subtract(24, 'hours') : moment(curretTime).subtract(item, 'days');
        const timeUnit = item === 1 ? 'hour' : 'day';
        const timeUnitStepSize = item === 1 || item === 14 ? 2 : item === 3 || item === 7 ? 1 : 7;
        return {
          ...result,
          [item]: { name, value, timeUnit, timeUnitStepSize }
        };
      }, {});
    },
    mounted() {
      this.initData();
    },
    methods: {
      async initData() {
        try {
          if (!this.hasProps) {
            this.webpage = await WebpageService.get(this.$route.params.id);
          } else {
            this.webpage = { ...this.webpagePropData };
          }
          this.handleChangeFilterChart(1);
          if (!this.$route.params.domainId) {
            this.$store.dispatch('setBreadcrumbAtIndex', {
              data: {
                path: `/webpages/${this.webpage.id}`,
                title: `View Webpages - URL ID ${this.webpage.id}`
              }, index: 2
            });
          }
        } catch {
          this.$showErrorMessage('Fetch webpage failed.');
        }
      },
      formatTime(date) {
        let [mdy, time] = date;
        mdy = mdy.split('/');
        const month = parseInt(mdy[0]);
        const day = parseInt(mdy[1]);
        const year = parseInt(mdy[2]);
        const formattedDate = year + '-' + month + '-' + day + 'T' + time;
        return formattedDate;
      },
      async handleChangeFilterChart(recentDaysNo) {
        const apiResponse = await WebpageService.getPerformance(this.$route.params.id, `?days=${recentDaysNo}`);
        const performanceData = (apiResponse || [])
          .map((item) => ({
            startedAt: new Date(item.started_at.replace(/\-/gim, '/') + ' GMT').getTime(),
            fetchTime: Number(Number(item.fetch_time).toFixed(2))
          }))
          .sort((a, b) => a.startedAt - b.startedAt);
        this.timeUnitMin = new Date(this.filterChartOptions[recentDaysNo].value.toDate()).getTime();
        const dataInDatasets = [];
        const labels = [];
        for (let index = 0, loopArrayLength = performanceData.length; index < loopArrayLength; index++) {
          dataInDatasets.push(performanceData[index].fetchTime);
          labels.push(performanceData[index].startedAt);
        }
        const datasets = [
          {
            label: 'URL Response Time (seconds)',
            data: dataInDatasets,
            borderWidth: 1,
            borderColor: '#04B0ED',
            pointBorderWidth: 2,
            pointBorderColor: 'transparent',
            pointHoverBorderColor: '#04B0ED',
            pointHoverRadius: 7,
            pointBackgroundColor: 'transparent'
          }
        ];
        this.timeUnit = this.filterChartOptions[recentDaysNo].timeUnit;
        this.timeUnitStepSize = this.filterChartOptions[recentDaysNo].timeUnitStepSize;
        this.chartData = {
          labels,
          datasets
        };
        setTimeout(() => {
          this.performanceChartKey = recentDaysNo;
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .label-desc {
    height: 16px;
    width: 30px;
  }
</style>
